var CfcEnvironment;
(function (CfcEnvironment) {
  CfcEnvironment["CI"] = "np-ci";
  CfcEnvironment["DEV"] = "np-dev";
  CfcEnvironment["QA"] = "np-qa";
  CfcEnvironment["STAGING"] = "np-staging";
  CfcEnvironment["CONSTG"] = "np-constg";
  CfcEnvironment["PROD"] = "p-prod";
})(CfcEnvironment || (CfcEnvironment = {}));

export { CfcEnvironment };
//# sourceMappingURL=common-types.esm.js.map
